import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import ArrowRight from "@limitless/icons/ArrowRight";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
import Paper from "@limitless/modern/surfaces/paper/Paper";

const useStyles = makeStyles(theme => ({
    headerText: {
        display: "flex",
        flexDirection: "row"
    },
    text: {
        marginLeft: "3px"
    },
    typography: {
        color: theme.palette.primary.main,
        fontWeight: 500,
        marginTop: 32,
        display: "flex",
        cursor: "pointer",
        alignItems: "end"
    }
}));

const LearnMoreSection = ({ title, body, subText, dialogTitle, iconImage }) => {
    const classes = useStyles();
    const [showDialog, setShowDialog] = React.useState(false);

    return (
        <Paper sx={{ backgroundColor: theme => theme.palette.info.main }}>
            <Grid container sx={{ padding: 3 }} spacing={0}>
                <Grid item xs={12}>
                    <Grid className={classes.headerText}>
                        <Typography color={theme => theme.palette.text.primary} variant="h6">
                            {title}
                        </Typography>
                    </Grid>
                    <Grid direction="row" display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="body2" className={classes.typography} onClick={() => setShowDialog(true)}>
                            {"Learn more"}
                            <ArrowRight fontSize="small" style={{ marginLeft: "10px" }} />
                        </Typography>
                        {iconImage}
                    </Grid>
                </Grid>
                {showDialog && (
                    <Dialog
                        open
                        title={dialogTitle}
                        onOkClick={() => setShowDialog(false)}
                        onClose={() => setShowDialog(false)}
                        okText="ok"
                        paperStyle={{ maxWidth: "478px" }}
                    >
                        <Typography variant="body2">{body}</Typography>
                        {subText && (
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {subText}
                            </Typography>
                        )}
                    </Dialog>
                )}
            </Grid>
        </Paper>
    );
};
LearnMoreSection.propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    subText: PropTypes.string,
    dialogTitle: PropTypes.string,
    iconImage: PropTypes.any
};
export default LearnMoreSection;
